import { langsAllowed } from './../Lang/lng';
import CONSTS from '../Consts/Consts';

export default function getQueryStringParams(query) {

    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                let [key, value] = param.split('=');
                params[key.toLowerCase()] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                return params;
            }, {}
            )
        : {};
};



const defaultparamsAllowed = [
    "queryid",
    "wid",
    "linkid",
    "ptype",
    "cid",
    "promocode",
    "gotopage",
    "from", 
    "h",
    "nickname",
    "wl",
    "hid",
    "hvt",
    "c",
    "sub3",
    "sub4",
    "code"
];

const gotoParam = "gotopage";

export function baseUrlFromQueryStr() {
    const queryString = getQueryStringParams(location.search);
    const imliveMaster = location.href.indexOf('w99') > -1 ? CONSTS.imliveWmaster99 : CONSTS.imliveWmaster;
    let baseUrl = (queryString['wl'] && queryString['wl'] != 'imlive.com') ? `https://${queryString['wl']}${CONSTS.directLinkHandler}` : imliveMaster;
    if (queryString['c'] && langsAllowed.indexOf(queryString['c']) > -1 && queryString['c'] != 'en-EN') {
        baseUrl = `${CONSTS.langImlive}${CONSTS.directLinkHandler}`;
    }
    return baseUrl;
}

export function buildQueryString(paramsAllowed = defaultparamsAllowed) {
    const queryString = getQueryStringParams(location.search);

    //transform linkid to ptype if its WL and there is linkid in query and vice versa for imlive
    if ((queryString.wl || queryString.c) && queryString.linkid) {
        let ptype = CONSTS.linkIDToPtype[queryString.linkid];
        if (ptype) {
            queryString.ptype = ptype;
        }
        if (queryString.c && queryString.linkid == 1319) {
            queryString.ptype = 22;
        }
        delete queryString.linkid;
    } else if (!queryString.wl && queryString.ptype) {
        if (!queryString.linkid) {
            const linkid = CONSTS.ptypeToLinkID[queryString.ptype];
            if (linkid) {
                queryString.linkid = linkid;
            }
        }
        delete queryString.ptype;
    }

    const redirectParameters = {};

    paramsAllowed.map(param => {
        if (queryString.hasOwnProperty(param)) {
            redirectParameters[param] = param.toLocaleLowerCase() == gotoParam ? encodeURIComponent(queryString[param]) : queryString[param];
            if (param == 'ptype' && redirectParameters.hasOwnProperty('linkid')) {
                delete redirectParameters.linkid;
            }
            //remove parameter c(culture) if its value is not supported by langsAllowed
            if (param == 'c' && langsAllowed.indexOf(queryString[param]) == -1) {
                delete redirectParameters[param];
            }
        }
    });

    //Object.keys(defaultValuesForParams).map(k => {
    //    if (!(k in redirectParameters)) {
    //        redirectParameters[k] = defaultValuesForParams[k];
    //    }
    //})

    return "?" + Object.keys(redirectParameters).map(key => key + '=' + redirectParameters[key]).join('&');
}